import { render, staticRenderFns } from "./CustomersHeader.vue?vue&type=template&id=229e0278&scoped=true"
import script from "./CustomersHeader.vue?vue&type=script&lang=js"
export * from "./CustomersHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e0278",
  null
  
)

export default component.exports